import React from 'react';
import { Loader } from '@mantine/core';
import { Button } from '../../../../components/Button';
import { asCurrency } from '../../shared/utils/dashboard-page.utils';
import classes from './dashboard-header.module.scss';

export type DashboardHeaderProps = {
  headerDateText: string;
  setIsFilterDialogOpen: (open: boolean) => void;
  anchorMonthSalesExTips: number;
  anchorMonthLabel: string;
  loading: boolean;
  isLightMode: boolean;
  onToggleThemeMode: () => void;
};

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  headerDateText,
  setIsFilterDialogOpen,
  anchorMonthSalesExTips,
  anchorMonthLabel,
  loading,
  isLightMode,
  onToggleThemeMode,
}) => (
  <section className={[classes.hero, isLightMode ? classes.heroLight : ''].filter(Boolean).join(' ')}>
    <div className={classes.heroCopy}>
      <Button
        variant="cancel"
        className={classes.heroDateButton}
        onClick={() => setIsFilterDialogOpen(true)}
        ariaLabel="בחירת פילטר תאריך"
        dataTestId="dashboard-header-date"
      >
        <span className={classes.heroChevron}>⌄</span>
        <h1 className={classes.heroTitle}>{headerDateText}</h1>
        <span className={classes.heroCalendar}>🗓</span>
      </Button>
      <div className={classes.heroMetricLine}>
        <span className={classes.heroText}>מכירות לא כולל טיפים - {anchorMonthLabel}</span>
        <span className={classes.metricPill}>{asCurrency(anchorMonthSalesExTips)}</span>
      </div>
    </div>
    <div className={classes.heroActions}>
      <Button
        variant="cancel"
        className={classes.themeToggleButton}
        onClick={onToggleThemeMode}
        ariaLabel={isLightMode ? 'Switch to dark mode' : 'Switch to light mode'}
        dataTestId="dashboard-header-theme-toggle"
      >
        <span
          className={[classes.themeToggleTrack, isLightMode ? classes.themeToggleTrackOn : '']
            .filter(Boolean)
            .join(' ')}
          aria-hidden="true"
        >
          <span className={classes.themeToggleThumb}>
            <svg
              className={classes.themeToggleIcon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="4.2" />
              <line x1="12" y1="2.6" x2="12" y2="5" />
              <line x1="12" y1="19" x2="12" y2="21.4" />
              <line x1="2.6" y1="12" x2="5" y2="12" />
              <line x1="19" y1="12" x2="21.4" y2="12" />
              <line x1="5.4" y1="5.4" x2="7.1" y2="7.1" />
              <line x1="16.9" y1="16.9" x2="18.6" y2="18.6" />
              <line x1="5.4" y1="18.6" x2="7.1" y2="16.9" />
              <line x1="16.9" y1="7.1" x2="18.6" y2="5.4" />
            </svg>
          </span>
        </span>
      </Button>
      {loading ? <Loader size="sm" /> : null}
    </div>
  </section>
);
